<template>
  <div class="member-form tongxin-layout">
    <h1 class="title-with-underline">
      請輸入掛號對象資料
    </h1>

    <form @submit.prevent="handleSubmit">
      

      <!-- 身分證字號 -->
      <div class="form-group">
        <label class="required">身分證字號</label>
        <input
          v-model="formData.idno"
          type="text"
          class="form-control"
          placeholder="請輸入身分證字號"
          maxlength="10"
          required
        />
        <div class="error-message" v-if="errors.idno">{{ errors.idno }}</div>
      </div>

      <!-- 出生年月日 -->
      <div class="form-group">
        <label class="required">出生年月日</label>
        <input
          v-model="formData.birthday"
          type="date"
          class="form-control"
          required
        />
        <div class="error-message" v-if="errors.birthday">{{ errors.birthday }}</div>
      </div>
    </form>

    <!-- 查詢結果 -->
    <div v-if="hasSearched" class="search-result">
      <h2 class="result-title">查詢結果</h2>
      
      <!-- 預約列表 -->
      <div class="appointment-list" v-if="reservations.length > 0">
        <ReservationCard
          v-for="(reservation, index) in reservations"
          :key="reservation.reservationId"
          :reservation="reservation"
          :isExpanded="expandedCards[index]"
          :isSelected="false"
          @click="toggleCard(reservation, index)"
        />
      </div>
      
      <!-- 空狀態 -->
      <div class="empty-state" v-else>
        <div class="empty-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 6v6l4 2"></path>
          </svg>
        </div>
        <p class="empty-text">查無預約紀錄</p>
      </div>
    </div>

    <div style="margin-bottom: 96px"></div>
    <div class="fixed-footer-navigation">
      <TongxinNavigation
        :canProceed="!isLoading"
        :backButtonIsVisible="true"
        :nextButtonIsVisible="true"
        :textForNextStep="'送出查詢'"
        @back="goBack"
        @next="handleSubmit"
      />
    </div>

    <!-- Loading overlay -->
    <div v-if="isLoading" class="loading-overlay">
      <b-spinner style="border-width: 2px" />
    </div>
  </div>
</template>

<script>
import TongxinNavigation from '@/components/web/proj/tongxin/layout/TongxinNavigation.vue'
import ReservationCard from '@/components/web/proj/tongxin/ReservationCard.vue'
import tongxinApi from '@/apis/web/tongxin'

export default {  
  components: {
    TongxinNavigation,
    ReservationCard,
  },
  inject: {
    showErrorModal: { default: null }
  },
  props: {
    memberId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      formData: {        
        idno: '',
        birthday: '',        
      },
      errors: {},
      isLoading: false,
      hasSearched: false,
      reservations: [],
      expandedCards: {},
    }
  },
  computed: {
    
  },
  created() {
   
  },
  methods: {
   

    validateForm() {
      this.errors = {}
      let isValid = true

      if (!this.formData.idno || !this.formData.idno.trim()) {
        this.errors.idno = '請輸入身分證字號'
        isValid = false
      } else if (!/^[A-Z][A-Z0-9]\d{8}$/.test(this.formData.idno.trim())) {
        this.errors.idno = '身分證字號或居留證號格式不正確'
        isValid = false
      }

      if (!this.formData.birthday) {
        this.errors.birthday = '請選擇出生年月日'
        isValid = false
      }

      return isValid
    },

    async handleSubmit() {
      if (!this.validateForm()) {
        return
      }

      try {
        this.isLoading = true
        const formattedBirthday = this.formatBirthday(this.formData.birthday)
        
        const response = await tongxinApi.getReservations(
          this.formData.idno.trim(),
          formattedBirthday,
          'all',
          null,
          null,
          100, // limit
          0 // offset
        )
        
        const data = response.data || response || []
        this.reservations = Array.isArray(data) ? data : []
        this.hasSearched = true
      } catch (error) {
        console.error('查詢失敗:', error)
        if (this.showErrorModal) {
          this.showErrorModal('查詢失敗', error.message || '查詢發生錯誤，請稍後再試')
        } else {
          alert('查詢發生錯誤，請稍後再試')
        }
      } finally {
        this.isLoading = false
      }
    },

    toggleCard(reservation, index) {
      this.$set(this.expandedCards, index, !this.expandedCards[index])
    },

   

    /**
     * 將 SAW API 生日格式轉換為 date input 格式
     * "1990/5/15 上午 12:00:00" → "1990-05-15"
     */
    formatBirthday(birthday) {
      if (!birthday) return ''
      // 已經是 YYYY-MM-DD 格式
      if (/^\d{4}-\d{2}-\d{2}$/.test(birthday)) return birthday
      // SAW API 格式：取日期部分，轉換斜線為橫線
      const datePart = birthday.split(' ')[0]
      if (!datePart) return ''
      const parts = datePart.split('/')
      if (parts.length !== 3) return ''
      const year = parts[0]
      const month = parts[1].padStart(2, '0')
      const day = parts[2].padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    goBack() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scoped>
.member-form {
  form {
    margin-top: 40px;

    .form-group {
      margin-bottom: 24px;

      label {
        display: block;
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;

        &.required::after {
          content: ' *';
          color: #dc3545;
        }
      }

      .form-control {
        width: 100%;
        padding: 12px;
        font-size: 16px;
        border: 2px solid #e0e0e0;
        border-radius: 8px;
        transition: border-color 0.3s;

        &:focus {
          outline: none;
          border-color: #207868;
        }

        &::placeholder {
          color: #999;
        }
      }

      select.form-control {
        cursor: pointer;
      }

      .error-message {
        color: #dc3545;
        font-size: 14px;
        margin-top: 4px;
      }
    }

    .reminder-green {
      background: #e8f5f3;
      border-left: 4px solid #207868;
      padding: 16px;
      margin-bottom: 24px;
      border-radius: 4px;
      font-size: 14px;
      color: #333;
      line-height: 1.6;
    }

    .btn {
      padding: 12px 24px;
      font-size: 16px;
      font-weight: 600;
      border-radius: 8px;
      transition: all 0.3s;

      &.btn-primary {
        background: #207868;
        border: none;
        color: white;

        &:hover:not(:disabled) {
          background: #186052;
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }

      &.btn-secondary {
        background: #6c757d;
        border: none;
        color: white;

        &:hover {
          background: #5a6268;
        }
      }

      &.btn-outline-danger {
        background: white;
        border: 2px solid #dc3545;
        color: #dc3545;

        &:hover:not(:disabled) {
          background: #dc3545;
          color: white;
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }
    }
  }

  .search-result {
    margin-top: 40px;

    .result-title {
      font-size: 20px;
      font-weight: bold;
      color: #207868;
      margin-bottom: 20px;
      text-align: center;
    }

    .appointment-list {
      display: flex;
      flex-direction: column;
    }

    .empty-state {
      text-align: center;
      padding: 40px 20px;

      .empty-icon {
        width: 80px;
        height: 80px;
        background: #f8f9fa;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 16px;

        svg {
          width: 40px;
          height: 40px;
          color: #ccc;
        }
      }

      .empty-text {
        font-size: 18px;
        color: #999;
      }
    }
  }
}
</style>
